module.exports = __webpack_public_path__ + "fonts/Gibson-SemiBold.34e79691.woff2";